import { SET_USER_LANGUAGE } from "../types.js";

export const acSuccess = (language, type) => ({
    type,
    language
});

export default (language) => (dispatch) => {
    dispatch(acSuccess(language, SET_USER_LANGUAGE));
}